const GLOBAL_LIST = {
  CLASS_BLOCK: 'CLASS_BLOCK',
  DURATION_TYPE: 'DURATION_TYPE',
  QUESTION_TYPE: 'QUESTION_TYPE',
  QUESTION_DISPLAY_MODE: 'QUESTION_DISPLAY_MODE',
  EXAM_PARTS: 'EXAM_PARTS',
  GRADING_SCALE: 'GRADING_SCALE',
  QUESTION_TYPE_FLASHCARD: 'QUESTION_TYPE_FLASHCARD',
  ASSESSMENT_TYPE: 'ASSESSMENT_TYPE',
  CLASSROOM_CONTENT_TYPE: 'CLASSROOM_CONTENT_TYPE',
  TYPE_LINK_SHARE: 'TYPE_LINK_SHARE',
  HIGH_SCHOOL: 'HIGH_SCHOOL',
  LOWER_SECONDARY_SCHOOL: 'LOWER_SECONDARY_SCHOOL',
  PRIMARY_SCHOOL_SUBJECTS: 'PRIMARY_SCHOOL_SUBJECTS',
  DIFFICULTY: 'DIFFICULTY',
  DIFFICULTY_EXERCISE: 'DIFFICULTY_EXERCISE',
  TOOL_DOCUMENT_TYPE: 'TOOL_DOCUMENT_TYPE',
  EDUCATIONAL_LEVEL: 'EDUCATIONAL_LEVEL',
}

export default GLOBAL_LIST
